import { MoveGenerator } from '../../../jscaip/AI/AI';
import { MancalaDistribution, MancalaMove } from './MancalaMove';
import { MancalaRules } from './MancalaRules';
export class MancalaMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const moves = [];
        const state = node.gameState;
        for (const coord of MancalaRules.getAllCoordOf(state.getCurrentPlayer(), config)) {
            if (state.getPieceAt(coord) > 0) {
                // if the house is not empty
                const move = MancalaMove.of(MancalaDistribution.of(coord.x, coord.y));
                if (config.mustContinueDistributionAfterStore) {
                    moves.push(...this.getPossibleMoveContinuations(state, coord.x, coord.y, move, config));
                }
                else {
                    const legality = this.rules.isLegal(move, state, config);
                    if (legality.isSuccess()) {
                        moves.push(move);
                    }
                }
            }
        }
        return moves;
    }
    getPossibleMoveContinuations(state, x, y, currentMove, config) {
        const moves = [];
        const previousDistributionResult = MancalaRules.getEmptyDistributionResult(state);
        const distributionResult = this.rules.distributeHouse(MancalaDistribution.of(x, y), previousDistributionResult, config);
        const stateAfterDistribution = distributionResult.resultingState;
        const isStarving = MancalaRules.isStarving(stateAfterDistribution.getCurrentPlayer(), stateAfterDistribution.board, config);
        const playerHasPieces = isStarving === false;
        if (distributionResult.endsUpInStore && playerHasPieces) {
            for (let i = 0; i < stateAfterDistribution.getWidth(); i++) {
                if (stateAfterDistribution.getPieceAtXY(i, y) > 0) {
                    const move = currentMove.add(MancalaDistribution.of(i, y));
                    moves.push(...this.getPossibleMoveContinuations(stateAfterDistribution, i, y, move, config));
                }
            }
            return moves;
        }
        else {
            return [currentMove];
        }
    }
}
